module.exports = __webpack_public_path__ + "img/cartao_jcb.c127ede8.png";